var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb-container"},[_c('div',{staticClass:"breadcrumb-content"},[_c('div',{staticClass:"breadcrumb-inner"},[_c('a-breadcrumb',_vm._l((_vm.value),function(item,index){return _c('a-breadcrumb-item',{key:index,style:(index == _vm.value.length -1 ? 'color: #1da1f2' : '')},[_vm._v(_vm._s(item)+"\n        ")])}),1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }